import { env } from 'next-runtime-env';

import { TokenManager } from '~shared/services/ClientTokenManager';

type Params = {
	userId: string;
	body?: { [key: string]: unknown };
	event: string;
	forceSendNoUser?: true;
	forceSendDemoUser?: true;
};

const origin = env('NEXT_PUBLIC_PUBLIC_API') ?? 'https://api.ifriend.ai';

export const sendEvent = async ({
	userId,
	event,
	body,
	forceSendNoUser,
	forceSendDemoUser,
}: Params): Promise<void> => {
	const { token, type } = TokenManager.getInfo();

	//we dont send any annals events for demo users but exceptions
	if (type === 'demo' && !forceSendNoUser && !forceSendDemoUser) {
		return;
	}
	if (!token) {
		return;
	}

	const endpoint = forceSendNoUser
		? `${origin}/annals/nouser/${event}`
		: `${origin}/annals/${userId}/${event}`;

	try {
		const response = await fetch(endpoint, {
			body: JSON.stringify(body),
			method: 'POST',
			keepalive: true,
			headers: {
				authorization: `Token token="${token}"`,
			},
		});
		if (!response.ok) {
			throw new Error(`Annals response status: ${response.status}`);
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error((error as Error).message);
	}
};
